import { Component, OnInit, DestroyRef, ChangeDetectorRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Property } from '@app/_models/propery.model';
import { AuthResponse } from '@app/_models/responses';
import { Role } from '@app/_models/role';
import { UserService, AuthenticationService } from '@app/_services';
import { PropertyService } from '@app/_services/property.service';
import { environment } from '@environments/environment';
import { faSearch, faBuilding, faArrowRight, faHouse, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-available-properties',
    templateUrl: './available-properties.component.html',
    styleUrls: ['./available-properties.component.css'],
    standalone: false
})
export class AvailablePropertiesComponent implements OnInit {

  loading = false;

  searchText = '';

  //communities: Community[];
  properties: Property[] = [];

  faSearch = faSearch;
  faHouse = faHouse;
  faBuilding = faBuilding;
  faArrowRight = faArrowRight;
  faCircleArrowRight = faCircleArrowRight;
  action: any;
  currentUser!: AuthResponse | null;
  operation = 'None';
  private destroyRef = inject(DestroyRef);

  constructor(private propertyService: PropertyService,
    private route: ActivatedRoute,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private router: Router) { }

  ngOnInit(): void {
    this.loading = true;

    this.authenticationService.currentUser
      ?.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (x) => {
          this.currentUser = x || null;
          this.loadProperties();
        }
      });

    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (params) => {
          this.action = params.get('action');
          this.searchText = '';
          this.loadProperties();
        }
      });
  }

  private loadProperties() {
    if (!this.currentUser || !this.action) {
      return;
    }

    this.loading = true;

    if (this.action == 'manage') {
      this.operation = 'Manage Users';
      this.loadAdminProperties();
    }
    else if (this.action == 'manage-numbers') {
      this.operation = 'Manage Phone Numbers';
      this.loadAdminProperties();
    }
    else if (this.action == 'manage-number') {
      this.operation = 'Add Phone Number';
      this.loadAdminProperties();
    }
    else if (this.action == 'log') {
      console.log('Loading access log properties');
      this.operation = 'Access Log';
      this.loadAdminProperties();
    }
    else if (this.action == 'notices') {
      this.operation = 'Notices';
      this.loadSubscribedProperties(true);
    }
    else {
      this.operation = 'Operate Gates';
      this.loadSubscribedProperties(false);
    }
    //this.ngOnInit();
  }

  private loadSubscribedProperties(autoOpenSingle: boolean) {
    this.propertyService.checkSubscriptions(this.currentUser!.username || '')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (properties) => {
          this.loading = false;
          this.properties = [...properties];
          this.cdr.detectChanges();
          if (autoOpenSingle && properties.length === 1 && properties[0].id != null) {
            this.loadPage(properties[0].id, this.action, true);
          }
        },
        error: () => {
          this.loading = false;
          this.toastr.error('Fail to retrieve properties.', 'Error');
        }
      });
  }

  private loadAdminProperties() {
    if (!this.isAdmin()) {
      this.router.navigate(['/']);
      return;
    }

    this.userService.getPropertiesByRoleAccessList(this.currentUser!.username || '', 'ROLE_ADMIN')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.properties = [...data];
          this.loading = false;
          this.cdr.detectChanges();
          if (!environment.production) {
            console.log('Property list:', data);
          }
        },
        error: () => {
          this.loading = false;
          this.toastr.error('Fail to retrieve properties.', 'Error');
        }
      });
  }

  isAdmin() {
    //return this.currentUser;
    if (this.currentUser) {
        if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
            return this.currentUser.role.includes(Role.ROLE_ADMIN);
        } else {
          return false;
        }

    }
    return false;
    //return this.currentUser && this.currentUser.role.includes('ROLE_ADMIN');
  }

  get filteredProperties(): Property[] {
    const search = this.searchText.trim().toLowerCase();
    if (!search) {
      return this.properties;
    }

    return this.properties.filter((property) => {
      console.log('Filtering property:', property.name);
      return property.name?.toLowerCase().includes(search);
    });
  }

  loadPage(propertyid: number, action: string, replaceUrl = false) {
    if (action == 'operate') {
      this.router.navigate(['/operate-device/' + propertyid]);
    }
    else if (action == 'manage') {
      this.router.navigate(['/access-management/' + propertyid]);
    }
    else if (action == 'log') {
      this.router.navigate(['/access-log/' + propertyid]);
    }
    else if (action == 'manage-numbers') {
      this.router.navigate(['/manage-numbers/list/' + propertyid]);
    }
    else if (action == 'manage-number') {
      this.router.navigate(['/manage-numbers/add/' + propertyid])
    }
    else if (action == 'notices') {
      // Skip the picker in history when it was bypassed automatically.
      this.router.navigate(['/notices', propertyid], { replaceUrl });
    }
    else {
      this.router.navigate(['/']);
    }
  }

}
